import './App.css'
import {useEffect} from 'react'
import {AppRoutes} from './routes'
import {AuthProvider} from './context/'
import {CatalogsProvider} from './context/catalogs/CatalogsProvider'
import './global.scss'
import {ChainsProvider} from './context/chains/ChainProvider'
import {resetStorageIfConfigChanged} from './utils/storage/appStorageReset'

function App() {
	useEffect(() => {
		resetStorageIfConfigChanged()
	}, [])

	return (
		<div className='App'>
			<AuthProvider>
				<CatalogsProvider>
					<ChainsProvider>
						<AppRoutes />
					</ChainsProvider>
				</CatalogsProvider>
			</AuthProvider>
		</div>
	)
}

export default App
